import { writeCookie } from "../../features/campaign";

export function saveFiltersToCookie() {
  const urlParams = new URLSearchParams(window.location.search);
  const filtersToSave: any = {};
  urlParams.forEach((value, key) => {
    if (key !== 'step' && key !== 'user' && key !== 'contact' && value !== 'null') {
      filtersToSave[key] = value;
    }
  });
  writeCookie("rybFilters", btoa(JSON.stringify(filtersToSave)), 365);
}
